import { Box, MenuItem, TextField } from "@mui/material";
import { signup } from "api/services/users";
import LoadingButton from "components/LoadingButton";
import { snack } from "components/toast";
import { ChangeEvent, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { selectSignup } from "redux/reducers/signUpSlice";
import { ResType, SubmitType } from "types";
import { getStates } from "api/services/common";
import { handleError } from "utils/handleError";
import Autocomplete from "@mui/material/Autocomplete";
import moment from "moment";
import { DesktopDatePicker } from "@mui/lab";
import { handleKeyDown } from "utils/keyDownPrevent";
import { STORAGE_SYSTEMS } from "data/constants";
import SafeTextField from "components/SafeTextField";


export const client_categories = [
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "HINDU_UNDIVIDED_FAMILY", label: "Hindu Undivided Family" },
  { value: "PARTNERSHIP_FIRM", label: "Partnership Firm" },
  { value: "LLP", label: "Limited Liability Partnership" },
  { value: "COMPANY", label: "Company" },
  { value: "ASSOCIATION_OF_PERSONS", label: "Association of Persons" },
  { value: "BODY_OF_INDIVIDUALS", label: "Body of Individuals" },
  { value: "TRUST", label: "Trust" },
  { value: "GOVERNMENT", label: "Government" },
  { value: "LOCAL_AUTHORITY", label: "Local Authority" },
  { value: "ARTIFICIAL_JURIDICAL_PERSON", label: "Artificial Juridical Person" },
];


interface GooglePrefill {
  legalName?: string;
  tradeName?: string;
  city?: string;
  state?: string;
  pincode?: string;
}

const PanDetails = ({ prefill }: { prefill?: GooglePrefill | null }) => {
  const [state, setState] = useState<any>({ storageSystem: 'AMAZON', ...(prefill || {}) });
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [forFocus, setForFocus] = useState(true);
  const [isVerified, setIsVerified] = useState(false);
  const [panNumber, setPanNumber] = useState("");
  const [panLoading, setPanLoading] = useState(false);
  const { email, password, mobileNumber, fullName, dialCode, countryCode, couponCode, channelPartnerId } = useSelector(selectSignup);

  const { data: states }: ResType = useQuery("states", getStates);
  const [showsubscription, setShowsubscription] = useState(false);
  let setexpirydate = new Date();
  setexpirydate.setDate(setexpirydate.getDate() + 6);
  const finalexpirydate = setexpirydate.getFullYear() + '-' + (setexpirydate.getMonth() + 1) + '-' + setexpirydate.getDate();
  const [orgconfig, setOrgconfig]: any = useState({
    expirydate: finalexpirydate,
    demo: 'yes',
    subscriptionmode: '',
    userslimit: '',
    stroagelimit: 26843545600
  });


  const { mutate, isLoading } = useMutation(signup, {
    onSuccess: (res: any) => {
      // localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("userId", JSON.stringify(res.data.userId));
      localStorage.setItem("isLogIn", JSON.stringify(res.data.isLogIn));
      if (res.data.storage_system === "MICROSOFT") {
        window.location.href = "/signup-onedrive";
      } else if (res.data.storage_system === "BHARATHCLOUD") {
        window.location.href = "/signup-bharathcloud";
      }
      else {
        window.location.href = "/";
      }
    },
    onError: (err: any) => {
      snack.error(handleError(err));
    },
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };
  const handleConfigChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.name == 'demo' && event.target.value == 'yes') {
      setOrgconfig(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
      setTimeout(() => {
        let date = new Date();
        date.setDate(date.getDate() + 6);
        const finalDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        setOrgconfig(prevState => ({
          ...prevState,
          'expirydate': finalDate
        }));
      }, 10);
      setShowsubscription(false);
    }
    if (event.target.name == 'demo' && event.target.value == 'no') {
      setShowsubscription(true);
      setOrgconfig(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
      setTimeout(() => {
        let date = new Date();
        date.setDate(date.getDate() + 28);
        const finalDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        setOrgconfig(prevState => ({
          ...prevState,
          ['expirydate']: finalDate,
          ['subscriptionmode']: 'monthly'
        }));
      }, 10);
    }
    if (event.target.name == 'subscriptionmode' && event.target.value == 'monthly') {
      setOrgconfig(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
      setTimeout(() => {
        let date = new Date();
        date.setDate(date.getDate() + 28);
        const finalDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        setOrgconfig(prevState => ({
          ...prevState,
          ['expirydate']: finalDate
        }));
      }, 10);
    } else if (event.target.name == 'subscriptionmode' && event.target.value == 'yearly') {
      setOrgconfig(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
      setTimeout(() => {
        let date = new Date();
        date.setDate(date.getDate() + 364);
        const finalDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        setOrgconfig(prevState => ({
          ...prevState,
          ['expirydate']: finalDate
        }));
      }, 10);
    } else {
      setOrgconfig(prevState => ({
        ...prevState,
        [event.target.name]: event.target.value
      }));
    }
  };

  const handleSubmit = async (e: SubmitType) => {
    e.preventDefault();
    if (!panNumber) return snack.error("Enter Pan Number");
    if (panNumber.length !== 10 || !PAN_REGEX.test(panNumber)) {
      setPanLoading(false);
      return snack.error("Invalid PAN Pattern");
    }
    if (!isValidPincode(state.pincode)) {
      return snack.error("Invalid Pincode");
    } else if (!isValidLimit(orgconfig.userslimit)) {
      return snack.error("User Limit Exceeds 500 and above 0")
    } else {
      mutate({
        ...state,
        email,
        password,
        mobileNumber,
        panNumber,
        dialCode,
        countryCode,
        category: state.category,
        config: orgconfig,
        userName: fullName.trim(),
        ...(couponCode && { couponCode }),
        ...(channelPartnerId && { channelPartnerId }),
      });
    }
  };
  const PAN_REGEX = /^[A-Z]{3}[A,B,C,F,G,H,L,J,P,T]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}$/;

  // const verifyPan = async () => {
  //   if (!panNumber) return snack.error("Enter Pan Number");

  //   setPanLoading(true);
  //   if (panNumber.length !== 10 || !PAN_REGEX.test(panNumber)) {
  //     setPanLoading(false);
  //     return snack.error("Invalid PAN Pattern");
  //   }

  //   try {
  //     let token: any = await getSandboxToken();

  //     let response: any = await getPanDetails({
  //       panNumber,
  //       token: token?.data?.access_token,
  //     });
  //     if (response.data.status === "INVALID") {
  //       return snack.error("Invalid PAN");
  //     }
  //     if (response.data.status === "NOT-VALID") {
  //       return snack.error("Not a Valid PAN");
  //     }
  //     const formateddata = getFabUtilityClass(response.data)

  //     setState({
  //       category: formateddata?.category,
  //       firstName: formateddata?.firstName,
  //       middleName: formateddata?.middleName,
  //       lastName: formateddata?.lastName,
  //       fullName: formateddata?.fullName,
  //       legalName: formateddata?.fullName,
  //       // tradeName: data?.data?.tradeName,
  //       // dateOfFormation: data?.data?.last_updated,
  //       // buildingName: data?.data?.buildingName,
  //       // street: data?.data?.street,
  //       // city: data?.data?.city,
  //       // state: data?.data?.state,
  //       // pincode: data?.data?.pinCode,
  //     });
  //     setIsVerified(true);
  //   } catch (e: any) {
  //     if (e.response?.data?.code === 422) {
  //       snack.error("Invalid PAN");
  //     } else {
  //       snack.error(e.response?.data?.message);
  //     }
  //   } finally {
  //     setPanLoading(false);
  //   }
  // };

  // const PanAdornment = () => {
  //   return (
  //     <>
  //       {panLoading && <CircularProgress size="1rem" />}
  //       {isVerified && !panLoading && <CheckCircleIcon fontSize="small" sx={{ color: "green" }} />}
  //       {!isVerified && !panLoading && (
  //         <Button color="error" disabled={panLoading} size="small" onClick={verifyPan}>
  //           Verify
  //         </Button>
  //       )}
  //     </>
  //   );
  // };

  const getFabUtilityClass = (input: any) => {

    const pandetails = {
      firstName: '',
      lastName: '',
      category: '',
      middleName: '',
      fullName: '',
      legalName: '',
    }
    let fullname = "";

    if (input.first_name) {
      pandetails.firstName = input.first_name
      fullname += input.first_name + " "
    }
    if (input.middle_name) {
      pandetails.middleName = input.middle_name
      fullname += input.middle_name + " "
    }
    if (input.last_name) {
      pandetails.lastName = input.last_name
      fullname += input.last_name
    }
    if (input.full_name) {
      pandetails.fullName = input.full_name
    } else {
      pandetails.fullName = fullname
    }
    if (input.category) {
      pandetails.category = input.category
    }
    return pandetails
  }
  const isValidPincode = (pincode) => {
    const pincodePattern = /^[1-9]{1}[0-9]{5}$/;
    if (typeof (pincode) !== null && typeof (pincode) !== undefined && pincode !== "" && pincode !== null && pincodePattern.test(pincode)) {
      return true
    } else {
      return false
    }
  }

  const isValidLimit = (limit) => {
    if (Number(limit) > 0 && Number(limit) <= 500) {
      return true
    } else {
      return false
    }
  }

  const handlePanChange = (e: any) => {
    setPanNumber(e.target.value.toUpperCase());
    setIsVerified(false);
  };

  const handleFocus = () => {
    if (forFocus)
      setIsDatePickerOpen(true);
    setForFocus(true);
  };

  const handleSelect = () => {
    setIsDatePickerOpen(false);
    setForFocus(false);
  };

  return (
    <>
      <Box>
        <TextField
          required
          onChange={handlePanChange}
          value={panNumber}
          sx={{ mt: 2 }}
          label="PAN"
          name="panNumber"
          size="small"
          fullWidth
        />
      </Box>
      {true && (
        <form onSubmit={handleSubmit}>
          <TextField
            sx={{ mt: 2 }}
            variant="outlined"
            size="small"
            fullWidth
            select
            onChange={handleChange}
            value={state.category ?? ""}
            InputLabelProps={{ shrink: true }}
            required
            name="category"
            label="Constitution of Business"
          >
            {client_categories.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>
          {state.category === "Individual" && (
            <>
              <SafeTextField
                sx={{ mt: 2 }}
                required
                onChange={handleChange}
                value={state.fullName}
                label="Full Name / Legal Name"
                size="small"
                name="FullName"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
              />
              <SafeTextField
                sx={{ mt: 2 }}
                onChange={handleChange}
                value={state.tradeName}
                label=" Trade Name"
                size="small"
                name="tradeName"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
              />
            </>
          )}
          {state.category !== "Individual" && (
            <>
              <SafeTextField
                required
                onChange={handleChange}
                value={state.legalName}
                sx={{ mt: 2 }}
                label="Legal Name / Organization Name"
                name="legalName"
                size="small"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
              />
              <SafeTextField
                sx={{ mt: 2 }}
                onChange={handleChange}
                value={state.tradeName}
                label="Trade Name"
                size="small"
                name="tradeName"
                fullWidth
                inputProps={{ maxLength: 100, minLength: 3 }}
              />
            </>
          )}
          <DesktopDatePicker
            label="Effective Date of Registration"
            inputFormat="dd-MM-yyyy"
            value={state?.registrationDate ? moment(state?.registrationDate, 'DD-MM-YYYY').toDate() : null}
            maxDate={moment().toDate()}
            onChange={(v) => {
              setState((draft: any) => ({ ...state, registrationDate: v ? moment(v, 'DD-MM-YYYY').toDate() : null }));
              handleSelect();
            }}
            open={isDatePickerOpen}
            renderInput={(params) => (
              <TextField
                name="registrationDate"
                fullWidth
                size="small"
                sx={{ mt: 2 }}
                onKeyDown={handleKeyDown}
                onClick={() => { setIsDatePickerOpen(true); }}
                onFocus={handleFocus}
                autoComplete="off"
                {...params}
              />
            )}
          />
          <TextField
            required
            onChange={handleChange}
            value={state.buildingNo}
            sx={{ mt: 2 }}
            label="Building No. / Flat.No."
            name="buildingNo"
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            onChange={handleChange}
            value={state.floorNumber}
            sx={{ mt: 2 }}
            label="Floor No."
            name="floorNumber"
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            onChange={handleChange}
            value={state.buildingName}
            sx={{ mt: 2 }}
            label="Name of the Premises / Building"
            name="buildingName"
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            required
            onChange={handleChange}
            value={state.street}
            sx={{ mt: 2 }}
            label="Road / Street"
            name="street"
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            onChange={handleChange}
            value={state.location}
            sx={{ mt: 2 }}
            label="Locality / Sub-Locality"
            name="location"
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            required
            onChange={handleChange}
            sx={{ mt: 2 }}
            label="City / Town / Village"
            name="city"
            value={state.city}
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <TextField
            required
            onChange={handleChange}
            sx={{ mt: 2 }}
            label="District"
            name="district"
            value={state.district}
            size="small"
            fullWidth
            inputProps={{ maxLength: 100 }}
          />
          <Autocomplete
            sx={{ mt: 2 }}
            disablePortal
            onChange={(e, v) => setState({ ...state, state: v })}
            id="combo-box-demo"
            size="small"
            options={states?.data?.map((item: any) => item.name) || []}
            renderInput={(params) => (
              <TextField required {...params} label="State / Union Territory" />
            )}
          />
          <TextField
            onChange={handleChange}
            sx={{ mt: 2 }}
            value={state.pincode}
            name="pincode"
            label="PIN Code"
            inputProps={{
              pattern: "^[1-9]{1}[0-9]{5}$",
              title: "Enter valid pincode",
              maxLength: 6,
            }}
            size="small"
            fullWidth
            required
            error={!isValidPincode(state?.pincode) && state?.pincode !== "" && state?.pincode !== null && state?.pincode !== undefined}
            helperText={(!isValidPincode(state?.pincode) && state?.pincode !== "" && state?.pincode !== null && state?.pincode !== undefined) && 'Invalid Pincode'}
          />
          <TextField
            fullWidth
            label="Users Limit"
            name="userslimit"
            required
            size="small"
            type="number"
            inputProps={{ min: 1, max: 500 }}
            onChange={handleConfigChange}
            sx={{ mt: 2 }}
            value={orgconfig?.userslimit}
          />
          <TextField
            sx={{ mt: 2 }}
            size="small"
            fullWidth
            select
            onChange={handleChange}
            value={state?.storageSystem || ""}
            name="storageSystem"
            label="Storage"
          >
            {STORAGE_SYSTEMS.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </TextField>


          <LoadingButton
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            sx={{ mt: 3 }}
            loading={isLoading}
            disabled={isLoading}
            title="Submit"
          />
        </form>
      )}
    </>
  );
};
export default PanDetails;
